// src/icons/DiscountOutline.tsx
import React from "react";
var SvgDiscountOutline = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M11.8986 14.8773C11.9612 14.8404 12.0388 14.8404 12.1014 14.8773L15.3281 16.7765C15.4762 16.8636 15.658 16.7358 15.6261 16.567L14.8998 12.7231C14.8874 12.6571 14.9088 12.5893 14.9569 12.5425L17.7014 9.87407C17.8217 9.75712 17.7532 9.55297 17.5867 9.53221L13.8928 9.07155C13.8229 9.06283 13.7627 9.01796 13.7344 8.95344L12.1831 5.41747C12.1132 5.25794 11.8868 5.25794 11.8168 5.41747L10.2656 8.95344C10.2373 9.01796 10.1771 9.06283 10.1072 9.07155L6.41326 9.53221C6.24679 9.55297 6.17831 9.75712 6.29859 9.87407L9.04307 12.5425C9.09119 12.5893 9.11263 12.6571 9.10017 12.7231L8.37394 16.567C8.34204 16.7358 8.52383 16.8636 8.67191 16.7765L11.8986 14.8773Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C7.58157 20 4 16.4184 4 12C4 7.58157 7.58157 4 12 4C16.4184 4 20 7.58157 20 12C20 16.4184 16.4184 20 12 20Z",
      fill: "currentColor"
    }
  )
);
var DiscountOutline_default = SvgDiscountOutline;

export {
  DiscountOutline_default
};
